import React  from 'react'
import InnerStyles from './InnerStyles.module.css'
import useCustomData from './useCustomData'
import { NavLink } from 'react-router-dom'
const SubDoctor = () => {

    const data=useCustomData(`https://backendsurgylife-1.onrender.com/location`)
    const data1=useCustomData (`https://backendsurgylife-1.onrender.com/doctor`)

  return (
    <main>
      <section className={InnerStyles.breadgum}>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
                         <h1>Doctors</h1>

            </div>
          </div>

        </div>

      </section>

      <section className={`py-5 bx_shadow`}>
        <div className='container'>
          <div className='row'>
            <p>{data.tdesc}</p>
          {
            data1.map((treatments)=>{
              return(
                <div className='col-md-3'>
                  <div className='mb-3'>
                    
                 
                       <h6 className={'my-3 text-center'}>
                      <NavLink className={InnerStyles.navtreatments} to='/subdoctorqualification'>{treatments.dname}</NavLink>
                      </h6>
                  </div>
                </div>
              )
            })
          }
          </div>
        </div>
      </section>

    </main>
  )
}

export default SubDoctor












